import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CartItemSelectorService, CurrentCartItemPrice } from 'app/features/cart';
import { Async } from 'app/store';
import { Observable } from 'rxjs';
/**
 * CartCurrentListItemPriceComponent
 *
 * This component shows the price for a cart item
 */
@Component({
  selector: 'app-cart-current-list-item-price',
  templateUrl: './cart-current-list-item-price.component.html',
  styleUrls: ['./cart-current-list-item-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartCurrentListItemPriceComponent implements OnInit {
  /**
   * Cart item price type
   */
  @Input() priceType: 'ListPriceEach' | 'NetPriceEach' | 'NetPriceTotal' = 'NetPriceTotal';

  /**
   * Cart item ID
   */
  @Input() cartItemId: number;

  // Template variables
  public cartItemPrice$: Observable<Async<CurrentCartItemPrice>>;

  constructor(private cartItemSelectorService: CartItemSelectorService) {}

  ngOnInit(): void {
    this.cartItemPrice$ = this.cartItemSelectorService.getCartItemPrice(this.cartItemId);
  }
}
